export enum AnalyticsEvents {
  SignupCompleted = 'Signup completed',
  SignedIn = 'Signed In',
  SignedOut = 'Signed Out',
  /** Paid plan started (first checkout / new subscription). */
  PlanSubscribed = 'Plan Subscribed',
  /** User changed paid plan (upgrade/downgrade from billing UI). */
  PlanChanged = 'Plan Changed',
  /** Customer completed Paddle Retain with chose_to_cancel (includes survey fields). */
  SubscriptionCancelled = 'Subscription Cancelled',
  /** Subscription entered paused state (portal, schedule, or webhook-driven). */
  SubscriptionPaused = 'Subscription Paused',
  WarmupSettingsChanged = 'Warmup Settings Changed',
  WarmupReportExported = 'Warmup Report Exported',
  EmailAccountConnected = 'Email Account Connected',
  EmailAccountDisconnected = 'Email Account Disconnected',
  NotificationClicked = 'Notification Clicked',
  ExtensionIconClicked = 'Extension Icon Clicked',
  FeatureRequestClicked = 'Feature Request Clicked',
  BeaconOpened = 'Beacon Opened',
  TemplateInserted = 'Template Inserted',
  ExtraVariantAdded = 'Extra Variant Added',
  TrialExtended = 'Trial Extended',
  ReportsImageDownloaded = 'Reports Image Downloaded',
  /** Signup / welcome: name submitted (Account Details) */
  NameAdded = 'Name added',
  /** Signup: email verification completed */
  VerificationDone = 'Verification done',
  /** In-app onboarding: phone step completed */
  PhoneNumberCaptured = 'Phone Number captured',
  /** In-app onboarding: industry step completed */
  IndustryOrBusinessDomainCaptured = 'Industry/business domain captured',
  /** In-app onboarding: company size step completed */
  CompanySizeCaptured = 'Company Size captured',
  /** In-app onboarding: monthly send volume step completed */
  SendEmailsPerMonthCaptured = 'Send Emails per month captured',
  /** In-app onboarding: mailboxes step completed */
  MailboxesToWarmupCaptured = 'Mailboxes to Warmup captured',
  /** In-app onboarding: user confirmed a sales demo time slot */
  DemoMeetingBooked = 'demo meeting booked',
}
